import React from "react";
import styles from "./FundingUnavailable.module.css";

function FundingUnavailable({ onDone }) {
  return (
    <div className={styles.pageCenter}>
      <div className={styles.card}>
        <div className={styles.handshake} aria-hidden="true">
          <span className={styles.leftSleeve} />
          <span className={styles.rightSleeve} />
          <span className={styles.hand} />
        </div>
        <h2 className={styles.heading}>Thank You!</h2>
        <p className={styles.message}>
          Thank you for your interest in Global Exchanges with AIESEC in Nigeria!
        </p>
        <p className={styles.message}>
          Unfortunately, you are unable to proceed with the application at this time as funding for the programme is required.
        </p>
        <button type="button" className={styles.homeButton} onClick={onDone}>
          Back to Home
        </button>
      </div>
    </div>
  );
}

export default FundingUnavailable;